import { render, staticRenderFns } from "./setzhongzixiaofei.vue?vue&type=template&id=964290d2&"
import script from "./setzhongzixiaofei.vue?vue&type=script&lang=js&"
export * from "./setzhongzixiaofei.vue?vue&type=script&lang=js&"
import style0 from "./setzhongzixiaofei.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports